var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaImmobilien(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:none;}.cls-2{mix-blend-mode:lighten;opacity:0.5;}.cls-4{fill:#b02721;}.cls-5{fill:#3b485e;}.cls-6{fill:#fff;}.cls-7{fill:#59667c;}.cls-8{fill:#76b72a;}.cls-9{fill:#c7cfe2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.86,76.3,80,30.16,20.14,76.3a7.54,7.54,0,0,1-9.25-11.92l64-50L80,9.56l5.14,4.77,64,50.05a7.54,7.54,0,0,1-9.25,11.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.86,76.3,80,30.16,20.14,76.3a7.54,7.54,0,0,1-9.25-11.92l64-50L80,9.56l5.14,4.77,64,50.05a7.54,7.54,0,0,1-9.25,11.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80,30.16,22.15,74.76v75.68h115.7V74.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 42.27,
    y: 72.45,
    width: 30.19,
    height: 20.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 42.27,
    y: 107.67,
    width: 30.19,
    height: 25.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 87.54,
    y: 72.45,
    width: 30.19,
    height: 20.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87.54,
    y: 107.67,
    width: 30.19,
    height: 42.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 87.54,
    y: 72.45,
    width: 30.19,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 42.27,
    y: 72.45,
    width: 30.19,
    height: 6.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.88,117.73V107.67h-5v10.06H42.27v5H54.84v10.06h5V122.76H72.46v-5Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaImmobilien);
export default __webpack_public_path__ + "static/media/ka_immobilien.c5a77bb6606b1bea620853a6bd5a2032.svg";
export { ForwardRef as ReactComponent };